<div class="container-fluid m-0 p-0">
    <div class="row">
        <div class="col-12">
            <!-- <div class="welcome"> -->
            <div class="text-center">
                <h3>{{ "HI" | translate | titlecase }}, {{globals.currentUserInfo.username}}</h3>
            </div>
        </div>

        <div class="col-12">
            <div class="bg-white border p-5 text-center my-4">
                <h1 class="text-secondary mb-3">{{ "WELCOME_TO_ACADEMICA" | translate | titlecase }}</h1>
                <p class="font-16">
                    <!-- welcome to School Management System -->
                </p>
                <br />
                <app-loader [show]="showLoader"></app-loader>
                <div class="row text-center" *ngIf="!showLoader && !isCand">
                    <div class="chart-wrapper col-6">
                        <canvas baseChart [data]="doughnutChartData" [labels]="doughnutChartLabels"
                            [chartType]="doughnutChartType">
                        </canvas>
                    </div>
                    <div class="col-6">
                        <h3 class="text-secondary mb-3" >{{ "PENDING_FOR_ACTION" | translate | titlecase }}</h3>
                        <table *ngIf="candDashBoardData.length >= 1" class="table-striped" id="datatable">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>{{ "CANDUDATE_CODE" | translate | titlecase }}</th>
                                    <th>{{ "CANDIDATE_NAME" | translate | titlecase }}</th>
                                    <th>{{ "GENDER" | translate | titlecase }}</th>
                                    <th>{{ "SUBMISSION_DATE" | translate | titlecase }}</th>
                                    <th>{{ "STATUS" | translate | titlecase }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let res of candDashBoardData">
                                    <td>
                                        <button class="btn btn-sm btn-link text-warning" (click)="Preview(res?.candId)">
                                            {{res?.candId}}
                                        </button>
                                    </td>
                                    <td>{{res?.candCode}}</td>
                                    <td>{{(globals.lang == 'ar')? res.candNameAr : res.candNameEn}}</td>
                                    <td>{{ res.candGender == "M"? ("MALE" | translate | titlecase) : ("FEMALE" |
                                        translate |
                                        titlecase) }}</td>
                                    <td>{{res?.submissionDate}}</td>
                                    <td>{{res?.status}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>